export const POS_SET_DEVICE_ID = "POS_SET_DEVICE_ID";
export const POS_SET_APP_IS_PARALLEL = "POS_SET_APP_IS_PARALLEL";
export const POS_STATION_INITIALIZE = "POS_STATION_INITIALIZE";
export const POS_STATION_EDIT_MODE = "POS_STATION_EDIT_MODE";
export const POS_STATION_EDIT_AUTO_PRINT_RECEIPTS =
    "POS_STATION_EDIT_AUTO_PRINT_RECEIPTS";
export const POS_STATION_SET_IS_CC_PAYMENT_DISABLED =
    "POS_STATION_SET_IS_CC_PAYMENT_DISABLED";
export const POS_STATION_SET_IS_SUBMITTING_ORDER =
    "POS_STATION_SET_IS_SUBMITTING_ORDER";
export const POS_STATION_TOGGLE_TRAINING_MODE =
    "POS_STATION_TOGGLE_TRAINING_MODE";
export const POS_STATION_SET_CASHIER = "POS_STATION_SET_CASHIER";
export const POS_STATION_SET_ASSIGNING_TILL = "POS_STATION_SET_ASSIGNING_TILL";
export const POS_STATION_SET_ASSIGNED_TILL = "POS_STATION_SET_ASSIGNED_TILL";
export const POS_STATION_SET_TRAINING_MODE_ASSIGNED_TILL =
    "POS_STATION_SET_TRAINING_MODE_ASSIGNED_TILL";
export const POS_STATION_SET_TILL_ASSIGNMENT_SKIPPED =
    "POS_STATION_SET_TILL_ASSIGNMENT_SKIPPED";
export const POS_ERRORS_SET_TILL_ASSIGNMENT_ERROR_MESSAGE =
    "POS_ERRORS_SET_TILL_ASSIGNMENT_ERROR_MESSAGE";
export const POS_SET_STORE_SETTINGS = "POS_SET_STORE_SETTINGS";
export const POS_UPDATE_STORE_SETTINGS = "POS_UPDATE_STORE_SETTINGS";
export const POS_ALL_PREPS_INITIALIZE = "POS_ALL_PREPS_INITIALIZE";
export const POS_ADD_ONS_INITIALIZE = "POS_ADD_ONS_INITIALIZE";
export const POS_CURRENT_ORDER_SET_ID = "POS_CURRENT_ORDER_SET_ID";
export const POS_CURRENT_ORDER_SET_REF_NUM = "POS_CURRENT_ORDER_SET_REF_NUM";
export const POS_CURRENT_ORDER_SET_ID_REF_NUM_AND_NUMBER =
    "POS_CURRENT_ORDER_SET_ID_REF_NUM_AND_NUMBER";
export const POS_CURRENT_ORDER_REMOVE_REF_NUM =
    "POS_CURRENT_ORDER_REMOVE_REF_NUM";
export const POS_CURRENT_ORDER_CLEAR = "POS_CURRENT_ORDER_CLEAR";
export const POS_CURRENT_ORDER_SET_CUSTOMER_INFO =
    "POS_CURRENT_ORDER_SET_CUSTOMER_INFO";
export const POS_CURRENT_ORDER_SET_DRIVE_THRU_DETAILS =
    "POS_CURRENT_ORDER_SET_DRIVE_THRU_DETAILS";
export const POS_CURRENT_ORDER_SET_START_TIME =
    "POS_CURRENT_ORDER_SET_START_TIME";
export const POS_CURRENT_ORDER_SET_END_TIME = "POS_CURRENT_ORDER_SET_END_TIME";
export const POS_CURRENT_ORDER_SET_ORDER_NUMBER =
    "POS_CURRENT_ORDER_SET_ORDER_NUMBER";
export const POS_CURRENT_ORDER_SET_CHARITY_AMOUNT_CENTS =
    "POS_CURRENT_ORDER_SET_CHARITY_AMOUNT_CENTS";
export const POS_CURRENT_ORDER_SET_IS_TAX_EXEMPT =
    "POS_CURRENT_ORDER_SET_IS_TAX_EXEMPT";
export const POS_ORDERS_SET = "POS_ORDERS_SET";
export const POS_PENDING_ORDERS_SET = "POS_PENDING_ORDERS_SET";
export const POS_ADD_ORDER = "POS_ADD_ORDER";
export const POS_ORDERS_REMOVE = "POS_ORDERS_REMOVE";
export const POS_PENDING_ORDERS_REMOVE = "POS_PENDING_ORDERS_REMOVE";
export const POS_PENDING_VOIDED_ITEM_ADD = "POS_PENDING_VOIDED_ITEM_ADD";
export const POS_PENDING_VOIDED_COMBO_ADD = "POS_PENDING_VOIDED_COMBO_ADD";
export const POS_PENDING_VOIDED_ITEM_REMOVE = "POS_PENDING_VOIDED_ITEM_REMOVE";
export const POS_PENDING_VOIDED_COMBO_REMOVE =
    "POS_PENDING_VOIDED_COMBO_REMOVE";
export const POS_PENDING_VOIDED_ITEM_CHANGE_QUANTITY =
    "POS_PENDING_VOIDED_ITEM_CHANGE_QUANTITY";
export const POS_PENDING_VOIDED_COMBO_CHANGE_QUANTITY =
    "POS_PENDING_VOIDED_COMBO_CHANGE_QUANTITY";
export const POS_PENDING_VOIDED_CLEAR = "POS_PENDING_VOIDED_CLEAR";
export const POS_CURRENT_VOIDED_COMBOS_ADD = "POS_CURRENT_VOIDED_COMBOS_ADD";
export const POS_CURRENT_VOIDED_ITEMS_ADD = "POS_CURRENT_VOIDED_ITEMS_ADD";
export const POS_CURRENT_VOIDED_COMBOS_REMOVE =
    "POS_CURRENT_VOIDED_COMBOS_REMOVE";
export const POS_CURRENT_VOIDED_ITEMS_REMOVE =
    "POS_CURRENT_VOIDED_ITEMS_REMOVE";
export const POS_CURRENT_VOIDED_ITEMS_CHANGE_QUANTITY =
    "POS_CURRENT_VOIDED_ITEMS_CHANGE_QUANTITY";
export const POS_CURRENT_VOIDED_COMBOS_CHANGE_QUANTITY =
    "POS_CURRENT_VOIDED_COMBOS_CHANGE_QUANTITY";
export const POS_CURRENT_ORDER_VOIDED_CLEAR = "POS_CURRENT_ORDER_VOIDED_CLEAR";
export const POS_CURRENT_ORDER_ADD_DISCOUNT = "POS_CURRENT_ORDER_ADD_DISCOUNT";
export const POS_CURRENT_ORDER_REMOVE_DISCOUNT =
    "POS_CURRENT_ORDER_REMOVE_DISCOUNT";
export const POS_ERRORS_SET_DISCOUNT_ERROR_MESSAGE =
    "POS_ERRORS_SET_DISCOUNT_ERROR_MESSAGE";
export const POS_CURRENT_ORDER_ADD_EXISTING_GIFT_CARD_REQUEST =
    "POS_CURRENT_ORDER_ADD_EXISTING_GIFT_CARD_REQUEST";
export const POS_CURRENT_ORDER_UPDATE_EXISTING_GIFT_CARD_REQUEST =
    "POS_CURRENT_ORDER_UPDATE_EXISTING_GIFT_CARD_REQUEST";
export const POS_CURRENT_ORDER_REMOVE_EXISTING_GIFT_CARD_REQUEST =
    "POS_CURRENT_ORDER_REMOVE_EXISTING_GIFT_CARD_REQUEST";
export const POS_CURRENT_ORDER_ADD_NEW_GIFT_CARD_REQUEST =
    "POS_CURRENT_ORDER_ADD_NEW_GIFT_CARD_REQUEST";
export const POS_CURRENT_ORDER_UPDATE_NEW_GIFT_CARD_REQUEST =
    "POS_CURRENT_ORDER_UPDATE_NEW_GIFT_CARD_REQUEST";
export const POS_CURRENT_ORDER_REMOVE_NEW_GIFT_CARD_REQUEST =
    "POS_CURRENT_ORDER_REMOVE_NEW_GIFT_CARD_REQUEST";
export const POS_CURRENT_ORDER_SET_QSR_SELECTIONS =
    "POS_CURRENT_ORDER_SET_QSR_SELECTIONS";
export const POS_CURRENT_ORDER_SET_ALLERGY_WARNING_SHOWN =
    "POS_CURRENT_ORDER_SET_ALLERGY_WARNING_SHOWN";
export const POS_CURRENT_ORDER_SET_RESET_ON_CART_EMPTIED =
    "POS_CURRENT_ORDER_SET_RESET_ON_CART_EMPTIED";
export const POS_CURRENT_ORDER_SET_EZ_CATER_ORDER_TYPE =
    "POS_CURRENT_ORDER_SET_EZ_CATER_ORDER_TYPE";
export const POS_CURRENT_ORDER_SET_IS_SUBMITTED =
    "POS_CURRENT_ORDER_SET_IS_SUBMITTED";
export const POS_CURRENT_ORDER_SET_HAVE_PAYMENTS_COVERED_BALANCE =
    "POS_CURRENT_ORDER_SET_HAVE_PAYMENTS_COVERED_BALANCE";
export const POS_CURRENT_ORDER_SET_PRINT_RECEIPT =
    "POS_CURRENT_ORDER_SET_PRINT_RECEIPT";
export const POS_PAYMENT_SET_CASH_PAID_CENTS =
    "POS_PAYMENT_SET_CASH_PAID_CENTS";
export const POS_PAYMENT_ADD_TO_CASH_PAID_CENTS =
    "POS_PAYMENT_ADD_TO_CASH_PAID_CENTS";
export const POS_PAYMENT_SET_CHANGE_OWED_CENTS =
    "POS_PAYMENT_SET_CHANGE_OWED_CENTS";
export const POS_PAYMENT_APPLY_GIFT_CARD = "POS_PAYMENT_APPLY_GIFT_CARD";
export const POS_PAYMENT_REMOVE_GIFT_CARD = "POS_PAYMENT_REMOVE_GIFT_CARD";
export const POS_PAYMENT_SET_GIFT_CARDS = "POS_PAYMENT_SET_GIFT_CARDS";
export const POS_PAYMENT_APPLY_COMP_CARD = "POS_PAYMENT_APPLY_COMP_CARD";
export const POS_PAYMENT_REMOVE_COMP_CARD = "POS_PAYMENT_REMOVE_COMP_CARD";
export const POS_PAYMENT_ADD_CREDIT_CARD = "POS_PAYMENT_ADD_CREDIT_CARD";
export const POS_PAYMENT_APPLY_EZ_CATER = "POS_PAYMENT_APPLY_EZ_CATER";
export const POS_PAYMENT_APPLY_EXTERNAL_TENDER =
    "POS_PAYMENT_APPLY_EXTERNAL_TENDER";
export const POS_PAYMENT_REMOVE_EXTERNAL_TENDER =
    "POS_PAYMENT_REMOVE_EXTERNAL_TENDER";
export const POS_PAYMENT_CLEAR = "POS_PAYMENT_CLEAR";
export const POS_SET_RESERVE_ORDER_ID_ERRORED =
    "POS_SET_RESERVE_ORDER_ID_ERRORED";
export const POS_ERRORS_SET_PLACE_ORDER_AFTER_PAYMENTS_PROCESSED_ERRORED =
    "POS_ERRORS_SET_PLACE_ORDER_AFTER_PAYMENTS_PROCESSED_ERRORED";
export const POS_ERRORS_SET_CURRENT_ORDER_PLACEMENT_ERROR_MESSAGE =
    "POS_ERRORS_SET_CURRENT_ORDER_PLACEMENT_ERROR_MESSAGE";
export const POS_ERRORS_SET_LAST_CART_ENTITY_REMOVAL_ERROR_MESSAGE =
    "POS_ERRORS_SET_LAST_CART_ENTITY_REMOVAL_ERROR_MESSAGE";
